import { useEffect, useState } from "react";
import api from "../lib/api";
import { Scale } from "lucide-react";

const COLORS = ["#B23A2E", "#E2711D", "#C99A1E", "#3E8F99", "#7A4E9E", "#565E68", "#94A3AD", "#1C2530"];

export default function WinLossChart() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/productivity/win-loss").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return null;
  const p = d.proposals;
  const max = Math.max(1, ...d.reasons.map((r) => r.count));
  return (
    <div className="mb-6 border border-[#DFDAD0] bg-white" data-testid="win-loss-chart">
      <div className="flex flex-wrap items-center gap-4 px-4 py-3 border-b border-[#DFDAD0]">
        <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-wider text-[#1C2530]/60"><Scale className="w-3.5 h-3.5" /> Win / loss · why proposals lose</div>
        <div className="ml-auto flex items-center gap-4 font-mono text-[11px]">
          <span data-testid="winloss-won" className="text-[#2F7A3E]">{p.won} won</span>
          <span data-testid="winloss-lost" className="text-[#B23A2E]">{p.lost} rejected</span>
          <span data-testid="winloss-rate" className="text-[#1C2530]">{p.win_rate == null ? "—" : `${p.win_rate}% win rate`}</span>
          <span className="text-[#1C2530]/50">{d.lost_leads} leads lost with a reason</span>
        </div>
      </div>
      {(p.won + p.lost) > 0 && (
        <div className="flex h-2 mx-4 mt-3 overflow-hidden" data-testid="winloss-bar" title={`${p.won} won · ${p.lost} rejected`}>
          <div style={{ width: `${(p.won / (p.won + p.lost)) * 100}%` }} className="bg-[#2F7A3E]" />
          <div className="flex-1 bg-[#B23A2E]" />
        </div>
      )}
      {d.reasons.length === 0 ? (
        <div className="px-4 py-6 text-xs text-[#1C2530]/50 italic" data-testid="winloss-empty">No rejections logged yet. When a client rejects a proposal (Lead → Proposal → Rejected) or a call ends "not interested", the reason lands here.</div>
      ) : (
        <div className="p-4 space-y-2">
          {d.reasons.map((r, i) => (
            <div key={r.category} className="grid grid-cols-[200px_1fr_auto] items-center gap-3" data-testid={`winloss-reason-${i}`} title={r.samples.join("\n")}>
              <div className="text-sm text-[#1C2530] truncate">{r.category}</div>
              <div className="h-4 bg-[#EFECE5] relative">
                <div className="h-full" style={{ width: `${(r.count / max) * 100}%`, background: COLORS[i % COLORS.length] }} />
              </div>
              <div className="font-mono text-[11px] text-[#1C2530]/70 tabular-nums w-28 text-right">{r.count} · {r.pct}%<span className="text-[#1C2530]/40"> ({r.proposals}p/{r.leads}l)</span></div>
            </div>
          ))}
          <div className="font-mono text-[9px] text-[#1C2530]/40 pt-1">Hover a bar for verbatim reasons · p = rejected proposals, l = lost leads</div>
        </div>
      )}
    </div>
  );
}
